import React from 'react';

const Task = ({ ...attrs }) => (
  <svg viewBox="0 0 32 32" {...attrs}>
    <path
      style={{
        fill: 'none',
        stroke: 'currentColor',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: 4.978
      }}
      d="M13.4,26.1H6.3c-0.7,0-1.2-0.5-1.2-1.2V5.1c0-0.7,0.5-1.2,1.2-1.2h17.2c0.7,0,1.2,0.5,1.2,1.2v6.7"
    />
    <path
      style={{ fill: 'currentColor' }}
      d="m30.4 22.1a7.6 7.6 0 0 1-7.6 7.6 7.6 7.6 0 0 1-7.6-7.6 7.6 7.6 0 0 1 7.6-7.6 7.6 7.6 0 0 1 7.6 7.6z"
      fill="#6f6f71"
    />
    <g id="g8575_2_" transform="translate(47.5,69.5)">
      <path
        id="path8577_2_"
        style={{
          fill: 'none',
          stroke: '#FFFFFF',
          strokeWidth: 1.5,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4.978
        }}
        d="m-28.2-47.8 2.2 2.7 4.7-4.7"
      />
    </g>
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="4.978"
    >
      <path
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4.978
        }}
        d="m9 8.3h11.8"
      />
      <path
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4.978
        }}
        d="m9 11.4h11.8"
      />
      <path
        style={{
          fill: 'none',
          stroke: 'currentColor',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 4.978
        }}
        d="m9 14.5h8.1"
      />
    </g>
  </svg>
);

export default Task;
